import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Problems from './components/Problems';
import Services from './components/Services';
import CaseStudies from './components/CaseStudies';
import Advantages from './components/Advantages';
import ClientTypes from './components/ClientTypes';
import Program from './components/Program';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FAQ from './components/FAQ';

function Home() {
  return (
    <div className="bg-white">
      <Hero />
      <div id="about"><About /></div>
      <div id="problems"><Problems /></div>
      <div id="services"><Services /></div>
      <CaseStudies />
      <div id="advantages"><Advantages /></div>
      <ClientTypes />
      <div id="program"><Program /></div>
      <Testimonials />
      <div id="contact"><Contact /></div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="bg-white">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/faq" element={<FAQ />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
